import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => {
    return localStorage.getItem('preferred_currency') || 'USD';
  });
  const [exchangeRate, setExchangeRate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Obtener tipo de cambio al montar y cuando cambia la moneda
  useEffect(() => {
    if (currency === 'MXN') {
      fetchExchangeRate();
    }
  }, [currency]);

  const fetchExchangeRate = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API}/exchange-rate/current`);
      setExchangeRate(response.data);
    } catch (err) {
      console.error('Error obteniendo tipo de cambio:', err);
      setError('No se pudo obtener el tipo de cambio');
    } finally {
      setLoading(false);
    }
  };

  const toggleCurrency = () => {
    const newCurrency = currency === 'USD' ? 'MXN' : 'USD';
    setCurrency(newCurrency);
    localStorage.setItem('preferred_currency', newCurrency);
  };

  const formatPrice = (priceInUSD) => {
    if (!priceInUSD) return 'N/A';
    
    if (currency === 'USD') {
      return `$${priceInUSD.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
    } else {
      if (!exchangeRate || !exchangeRate.value) {
        return `$${priceInUSD.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`;
      }
      const priceInMXN = priceInUSD * exchangeRate.value;
      return `$${priceInMXN.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN`;
    }
  };

  const getRawPrice = (priceInUSD) => {
    if (!priceInUSD) return 0;
    
    if (currency === 'USD') {
      return priceInUSD;
    } else {
      if (!exchangeRate || !exchangeRate.value) {
        return priceInUSD;
      }
      return priceInUSD * exchangeRate.value;
    }
  };

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        setCurrency,
        toggleCurrency,
        exchangeRate,
        loading,
        error,
        formatPrice,
        getRawPrice,
        fetchExchangeRate
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency debe usarse dentro de CurrencyProvider');
  }
  return context;
}
